import React from 'react';
import moment from 'moment';
import { get } from 'lodash';

import TableHeader from '../TableHeader';
import CampaignFormModal from './CampaignFormModal';
import ImageLoader from '../ImageLoader';

const CampaignsList = ({ campaigns = [], total = 0 }) => {
  return (
    <React.Fragment>
      <div className='MainHeader'>
        <div className='MainHeader__left'>
          <h2 className='MainHeader__h2'>Campaigns list</h2>
          <p className='MainHeader__left__p'>Total {total.toLocaleString()} campaigns</p>
        </div>

        <div className='MainHeader__right'>
          <CampaignFormModal
            klassName='MainHeader__right__a MainHeader__right__a--bright-blue'
            label='Add Campaign'
            title='Add Campaign'
            reload
          />
        </div>
      </div>

      <div className='Table Table--campaigns-list'>
        {(() => {
          const columnHeaders = [
            {
              label: 'ID'
            },
            {
              label: 'Cover'
            },
            {
              label: 'Name'
            },
            {
              label: 'Date'
            },
            {
              label: 'Display'
            },
            {
              label: 'Manage',
            },
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {campaigns.map((campaign) => (
          <div className={'Table__row'} key={`campaign_${campaign.id}`}>
            <div className='Table__col'>{campaign.id}</div>

            <div className='Table__col'>
              <ImageLoader klassName='Campaigns__cover' url={campaign.coverImageUrl} />
            </div>

            <div className='Table__col'>{campaign.name}</div>

            <div className='Table__col'>{moment(get(campaign, 'startAt')).format('YYYY-MM-DD HH:mm')} - {moment(get(campaign, 'endAt')).format('YYYY-MM-DD HH:mm')}</div>
            <div className='Table__col'>
              {campaign.show ?
                <span className='Badge'>Show</span>
              :
                <span className='Badge Badge--red'>Hide</span>
              }
            </div>

            <div className='Table__col'>
              <div className='Table__controls'>
                <CampaignFormModal
                  klassName='Table__controls__a Table__controls__a--pencil'
                  title='Edit Campaign'
                  campaign={campaign}
                  reload
                />
                <a
                  className='Table__controls__a Table__controls__a--person'
                  href={`/${gon.currentProvider}/campaigns/${campaign.id}/user_campaigns`}
                />
              </div>
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default CampaignsList
